export const detectTicketCategoryIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete ticket category" || cleaned === "remove ticket category") {
        return { intent: "delete_ticket_category" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) ticket category/);
    if (deleteMatch) {
        return { intent: "delete_ticket_category", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create ticket category") || cleaned.includes("add ticket category")) {
        return { intent: "create_ticket_category" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create ticket category named (.+)/);
    if (createMatch) {
        return { intent: "create_ticket_category", name: createMatch[1].trim() };
    }

    return null;
};
